import cloneDeep from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'
import lang from '@/plugins/lang'
import { convertFormDataToObject } from '@/plugins/api/converter'
import { calcFieldQnt } from '@/helpers/calculation'

function getFilters(modalId) {
    let form = document.querySelector(`#${modalId} form`)

    form.querySelector('button[type="submit"]').click()

    return convertFormDataToObject(new FormData(form), false)
}

$.extend( $.fn.dataTable.ext.buttons, {
    filter: {
        text: lang.t('common:filters') + '<i class="fa-regular fa-filter ml-1"></i><span class="count">0</span>',
        className: 'dt-btn-filter btn-outline-primary',
        init: function ( dt, node, config ) {
            let modalId = dt.table().node().dataset.filterModal

            let btn = node[0]

            if (!modalId) {
                console.warn('The table must have the dataset filter-modal')
                return
            }

            let form = document.querySelector(`#${modalId} form`)

            if (!form) {
                console.warn(`Element not found with the selector: #${modalId} form`)
                return
            }

            btn.addEventListener('click', function() {
                $('#' + modalId).modal('show')
            })

            form.addEventListener('submit', (event) => event.preventDefault())

            config.data = getFilters(modalId)

            $('#' + modalId).on('hide.bs.modal', function(e) {
                // Previne que modals dentro da modal de filtro trigge o reload ao fecha-la. Ex. datapicker
                if (e.currentTarget === e.target) {
                    let newData = getFilters(modalId)

                    if (! isEqual(config.data, newData)) {
                        config.data = newData
                        dt.ajax.reload()
                    }
                }
            })

            dt.on('preXhr.dt', function ( e, settings, data ) {
                data.filter = cloneDeep(config.data)

                let filterQnt = calcFieldQnt(data.filter)

                btn.querySelector('.count').textContent = `${filterQnt}`

                if (filterQnt > 0) {
                    btn.classList.remove('btn-outline-primary')
                } else {
                    btn.classList.add('btn-outline-primary')
                }
            })
        }
    },
})
